import React from 'react';

const DeletePayrollModal = ({
    showDeleteModal,
    setShowDeleteModal,
    selectedPayroll,
    handleDeleteConfirm,
    getStatusBadge
}) => {
    if (!showDeleteModal || !selectedPayroll) return null;

    return (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header bg-danger text-white">
                        <h5 className="modal-title">
                            <i className="bi bi-exclamation-triangle me-2"></i>
                            Confirm Delete
                        </h5>
                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={() => setShowDeleteModal(false)}
                        ></button>
                    </div>

                    <div className="modal-body">
                        <div className="alert alert-warning" role="alert">
                            <i className="bi bi-exclamation-triangle-fill me-2"></i>
                            <strong>Warning:</strong> This action cannot be undone.
                        </div>

                        <p>Are you sure you want to delete the following payroll period?</p>

                        <div className="card border-0 bg-light">
                            <div className="card-body">
                                <h6 className="fw-bold">Payroll Period: {selectedPayroll.month_year}</h6>
                                <div className="row">
                                    <div className="col-md-6">
                                        <small className="text-muted d-block">Period</small>
                                        <strong>
                                            {new Date(selectedPayroll.from_date).toLocaleDateString()} to {new Date(selectedPayroll.to_date).toLocaleDateString()}
                                        </strong>
                                    </div>
                                    <div className="col-md-6">
                                        <small className="text-muted d-block">Status</small>
                                        <span className={`badge ${getStatusBadge(selectedPayroll.status)}`}>
                                            {selectedPayroll.status}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="alert alert-danger mt-3" role="alert">
                            <i className="bi bi-info-circle me-2"></i>
                            <strong>Note:</strong> Deleting this payroll period may affect salary calculations and reports.
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light border-secondary-subtle"
                            onClick={() => setShowDeleteModal(false)}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleDeleteConfirm}
                        >
                            <i className="bi bi-trash me-2"></i>
                            Delete Payroll Period
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeletePayrollModal;